export default __webpack_public_path__ + "static/media/fixture1_filter_lose.1e131bae.png";